<template>
  <span class="playerList_itemPanel" @click="goDetail(item)">
    <span class="player_item_left" :class="item.playerLogo ? 'isLogo' : ''">
      <img :src="item.playerLogo" v-if="item.playerLogo" />
    </span>
    <span class="player_item_right">
      <span class="playerName" v-text="item.playerName"></span>
      <template v-if="mode === 'mode_other'">
        <span class="playerBirthDate" v-text="item.birthDate"></span>
        <span
          class="playerOther"
          v-text="
            `${_valPerFormatHandler(item.height, 'cm')} ${_valPerFormatHandler(
              item.weight,
              'kg'
            )}`
          "
        ></span>
      </template>
      <template v-if="mode === 'mode_sports'">
        <span class="playerDelegation">
          <span
            class="delegationLogo"
            :class="item.delegationLogo ? 'isLogo' : ''"
          >
            <img v-if="item.delegationLogo" :src="item.delegationLogo" />
          </span>
          <span class="delegationName" v-text="item.delegationName"></span>
        </span>
        <span class="playerSports" v-text="item.sportCN"></span>
      </template>
    </span>
    <span class="playerSex" :class="item.gender"></span>
  </span>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'playerList_itemPanel',
  mixins: [cup_base_data_mixin],
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          playerId: 'WUSG31111',
          playerName: '张靖宇',
          playerLogo: '',
          gender: 'f',
          birthDate: '1991.04.23',
          height: '178',
          weight: '68',
          sportCN: '篮球',
          delegationLogo: '',
          delegationName: '中国',
        }
      },
    },
    detailPathName: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'mode_other', //mode_sports: 代表团+运动项目；mode_other：生日+身高+体重
    },
    fromPage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  methods: {
    goDetail(item) {
      console.debug(item, this.detailPathName)
      if (this.fromPage && this.fromPage === 'CSMeetPlayerIndex') {
        let currPlayerIndexPage = {
          delegationId: item.delegationId,
          sportsId: item.sportsId,
        }
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currPlayerIndexPage',
          JSON.stringify(currPlayerIndexPage)
        )
      }
      if (this.detailPathName) {
        this.pageJump(
          this.$router,
          `${this.detailPathName}_${this.currCid}`,
          {
            playerId: item.playerId,
            sid: item.seasonCode,
          },
          item
        )
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .playerList_itemPanel {
    position: relative;
    width: calc(20% - 1.11vw);
    margin: 1.38vw 1.38vw 0 0;
    height: 9.027vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 0.694vw;
    border: 1px solid var(--mixtmt_greyColor5);
    background-color: var(--mixtmt_whiteColor);
    overflow: hidden;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    position: relative;
    -webkit-transition: color 0.3s linear;
    transition: color 0.3s linear;
    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: var(--mixtmt_mainColor);
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transform-origin: 0 50%;
      transform-origin: 0 50%;
      -webkit-transition-property: transform;
      transition-property: transform;
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-timing-function: ease-out;
      transition-timing-function: ease-out;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    .player_item_left {
      width: 6.25vw;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-size: contain;
      background-position: left top;
      background-image: var(--mixtmt_default_playerLogo);
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .player_item_right {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10;
      width: calc(100% - 6.25vw);
      height: 100%;
      padding: 0.694vw 0.694vw 1.041vw 0.694vw;
      /* background-image: var(--mixtmt_playerItem_bg);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: left top; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      color: var(--mixtmt_greyColor4);
      -webkit-transition: color 0.3s linear;
      transition: color 0.3s linear;
      .playerName {
        display: -webkit-box;
        width: calc(100% - 1.66vw);
        height: 3.33vw;
        font-size: 1.388vw;
        line-height: 1.66vw;
        font-weight: bold;
        overflow: hidden;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-word;
        color: var(--mixtmt_greyColor3);
        -webkit-transition: color 0.3s linear;
        transition: color 0.3s linear;
      }
      .playerBirthDate {
        padding: 0.694vw 0 0.347vw 0;
        height: 2.43vw;
        width: 100%;
        font-size: 0.972vw;
        line-height: 1.38vw;
      }
      .playerOther {
        width: 100%;
        font-size: 0.972vw;
        line-height: 1.38vw;
      }
      .playerDelegation {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 1.38vw;
        .delegationLogo {
          position: relative;
          width: 2.083vw;
          height: 1.38vw;
          overflow: hidden;
          background-color: var(--mixtmt_greyColor0);
          &.isLogo {
            background-color: transparent;
          }
          &::before {
            content: '\20';
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            border: 1px solid var(--mixtmt_greyColor5);
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .delegationName {
          font-size: 0.972vw;
          padding-left: 0.347vw;
        }
      }
      .playerSports {
        padding: 1px 0.2778vw;
        font-size: 0.833vw;
        line-height: 1.38vw;
        border: 1px solid var(--mixtmt_greyColor4);
        border-radius: 0.208vw;
        -webkit-transition: border 0.3s linear;
        transition: border 0.3s linear;
      }
    }
    .playerSex {
      position: absolute;
      right: 0.694vw;
      top: 0.694vw;
      z-index: 12;
      width: 1.11vw;
      height: 1.11vw;
      border-radius: 50%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      &.M {
        background-image: var(--mixtmt_gender_male_icon);
      }
      &.F {
        background-image: var(--mixtmt_gender_female_icon);
      }
    }
  }
}

.mixtmt_pc {
  .playerList_itemPanel {
    &:hover {
      cursor: pointer;
      background-color: var(--mixtmt_greyColor8);
      border: 1px solid var(--mixtmt_mainColor2);
      &::before {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
      }
      .player_item_right {
        color: var(--mixtmt_whiteColor);
        .playerName {
          color: var(--mixtmt_whiteColor);
        }
        .playerSports {
          border: 1px solid var(--mixtmt_whiteColor);
        }
      }
    }
  }
}
</style>
